export default function validate(data) {
  const errors = {};

  if (!data.id) errors.id = "You Must Insert a Conversion Id";
  return errors;
}
